import request from '@/utils/request'
import {dealDownloadFileResponse} from "@/api/file";
import {formatDataFromSever,formatMainDataFromSever} from "@/views/WorkSheet/xml-manager";
import {encrypt} from "@/utils/encrypt";

export function getWorkSheetList({userId,sDate='',eDate='',typeIds='',statusId='',menuModuleId=0, key = '',onlyTo21V=false}) {
    // console.log('bb',userId,sDate,eDate,typeIds,statusId, key)
    return request({
        url: `/appi/Operate/GetWorkSheetList?userId=${encrypt(userId)}&sDate=${sDate}&eDate=${eDate}&typeIds=${typeIds}&statusId=${statusId}&menuModuleId=${menuModuleId}&key=${key}&onlyTo21V=${onlyTo21V}`
    })
    // return request({url: `/appi/Users/UserList?uId=${userId}&key=${key}`}).then(res=>{
    //     res.data = res.data.map(item=>{
    //         const {typeId, typeName} = item;
    //         return {cateName:typeName, cateId: typeId}
    //     })
    //     return Promise.resolve(res);
    // })
}

export function getDDLList({userId,type=''}) {
    return request({url: `/appi/Operate/GetDDLList?userId=${userId}&type=${type}`}).then(res=>{
        res.data = res.data.map(item=>{
            const {dictId, dictValue} = item;
            return {value:dictId, label: dictValue}
        })
        return Promise.resolve(res);
    })
}

export function SaveWorkSheet(data) {
    console.log('dataaaaa',data.p)
    // return;
    return request({
        url: `/appi/Operate/SaveWorkSheet`,
        data: {
            id: data.p.id,//encrypt(userId),
            sessionCode:data.p.sessionCode,
            sheetCode:data.p.sheetCode,
            sheetTypeIds:data.p.sheetTypeIds,
            title:data.p.title,
            content: data.p.content,
            alertLevel:data.p.alertLevel,
            status:data.p.status,
            userId:data.p.userId,
            flowtype:data.p.flowtype,
            toUIds:data.p.toUIds,
            ccUIds:data.p.ccUIds,
            itemContent:data.p.itemContent,
            sample:data.p.sample,
            sampleLog:data.p.sampleLog,

            companyType:data.p.companyType,
			companyName:data.p.companyName,
            jxsName:data.p.jxsName,
			contactUser:data.p.contactUser,
			tel:data.p.tel,
			address:data.p.address,
			email:data.p.email,
            account:data.p.account,
            sendMail:data.p.sendMail
        }
    });
}

export function SaveWorkSheetMain(data) {
    console.log('data',data)
    return request({
        url: `/appi/Operate/SaveWorkSheetMain`,
        data:{
            userId:data.p.userId,
            id: data.p.id,//encrypt(userId),
            sessionCode:data.p.sessionCode,
            sheetCode:data.p.sheetCode,
            sheetTypeIds:data.p.sheetTypeIds,
            title:data.p.title,
            content: data.p.content,
            alertLevel:data.p.alertLevel,
            sample:data.p.sample,
            companyType:data.p.companyType,
            companyName:data.p.companyName,
            jxsName:data.p.jxsName,
            contactUser:data.p.contactUser,
            tel:data.p.tel,
            address:data.p.address,
            email:data.p.email,
            account:data.p.account
        }
    });
}

export function SaveWorkSheetSub(data) {
    console.log('data',data)
    return request({
        url: `/appi/Operate/SaveWorkSheetSub`,
        data:{
            userId:data.p.userId,
            logId: data.p.logId,//encrypt(userId),
            wsId:data.p.wsId,
            toUIds:data.p.toUIds,
            ccUIds:data.p.ccUIds,
            finished:data.p.finished,
            itemContent:data.p.itemContent,
            sampleLog:data.p.sampleLog,
        }
    });
}
export function Save21VResult(data) {
    // console.log('data',data)
    return request({
        url: `/appi/Operate/Save21VResult`,
        data:data.p
    });

}

export function SaveWorkSheetSub2024(data) {
    // console.log('data',data)
    return request({
        url: `/appi/Operate/SaveWorkSheetSub2024`,
        data:data.p
    });

}

export function getWorkSheetDetail({userId,Id}){
    
    return request({
        url: `/appi/Operate/GetWorkSheetDetail?userId=${encrypt(userId)}&Id=${Id}`
    }).then(res => {
        console.log('cc',res.data[0][0])
        res.data = formatMainDataFromSever(res.data[0][0]);
        // console.log('bb',res.data)
        return Promise.resolve(res);
        // return res;
    });
}


export function getWorkSheetDetailSub({userId,Id}){
    
    return request({
        url: `/appi/Operate/GetWorkSheetDetail?userId=${userId}&Id=${Id}`
    }).then(res => {
        // console.log('cc',res.data)
        res.data = formatDataFromSever(res.data[1]);
        // console.log('bb',res.data)
        return Promise.resolve(res);
    });
}

export function getWorkSheetDetailUrl({userId,Id}){
    
    return request({
        url: `/appi/Operate/GetWorkSheetDetail?userId=${userId}&Id=${Id}`
    }).then(res => {
        // console.log('cc',res.data)
        res.data = formatDataFromSever(res.data[2]);
        // console.log('bb',res.data)
        return Promise.resolve(res);
    });
}

export function getWorkSheetDetailAll2024({userId,Id,isGuest=false}){
    return request({
        url: `/appi/Operate/GetWorkSheetDetail2024?userId=${encrypt(userId)}&Id=${Id}&isGuest=${isGuest}`
    }).then(res => {
        // 先捕获原始值（基本类型，不受后面 mutation 影响）
        const rawSample = res.data[0]?.[0]?.sample;
        const rawSampleLog = res.data[1]?.[0]?.sampleLog;
        console.log('【原始API值】main.sample:', JSON.stringify(rawSample), '| sub.sampleLog:', JSON.stringify(rawSampleLog));
        // 深克隆后再打印对象，避免 mutation 导致显示不一致
        const mainRaw = res.data[0]?.[0];
        const subRaw = res.data[1]?.[0];
        if (mainRaw !== undefined && mainRaw !== null) console.log('【原始API完整对象-深克隆】main:', JSON.parse(JSON.stringify(mainRaw)));
        if (subRaw !== undefined && subRaw !== null) console.log('【原始API完整对象-深克隆】sub:', JSON.parse(JSON.stringify(subRaw)));
        var main = formatMainDataFromSever(res.data[0][0]);
        var sub = formatDataFromSever(res.data[1]);
        var url = formatDataFromSever(res.data[2]);
        res.data = {main,sub,url};
        // console.log('bb',res.data)
        return Promise.resolve(res);
        // return res;
    });
}

export function Set21VCode({userId,Id,code21V}){
    return request({
        url: `/appi/Operate/Set21VCode?userId=${encrypt(userId)}&wsId=${encrypt(Id)}&code21V=${code21V}`
    }).then(res => {
        return Promise.resolve(res);
        // return res;
    });
}

export function getCompanyInfo({userId,sessionCode = ''}) {
    return request({
        url: `/appi/Operate/getCompanyInfo?userId=${userId}&sessionCode=${sessionCode}`
    })
}

export function getSheetCode({userId}) {
    // console.log('dddd')
    return request({
        url: `/appi/Operate/getSheetCode?userId=${userId}`
    })
}
/**
 * 设置截单
 * @param userId
 * @param productId
 * @returns {AxiosPromise}
 * @constructor
 */
 export function setFinish({userId, wsId,type,finished=true}) { 
    return request({url: `/appi/Operate/SetFinish?userId=${userId}&wsId=${wsId}&type=${type}&finished=${finished}`})
}


export function SetRemark({userId, wsId,remark,flag}) { 
    // return request({url: `/appi/Operate/SetRemark?userId=${userId}&wsId=${wsId}&remark=${remark}&flag=${flag}`})
    return request({
        url: `/appi/Operate/SetRemark`,
        data:{
            userId,//encrypt(userId),
            wsId,
            remark,   
            flag    
        }
    });
}

//获得导入的订单日志列表
export function GetRenewLogList({userId}) {
    // console.log('bb',userId,sDate,eDate,typeIds,statusId, key)
    return request({
        url: `/appi/Operate/GetRenewLogList?userId=${encrypt(userId)}`
    })
    
}

export function ImportRenewOrderExcel2Tmp({userId,ym, formData}) {
    return request({
        url: `/appi/Operate/ImportRenewOrderExcel2Tmp?userId=${userId}&ym=${ym}`,
        data: formData
    })
    // .then(res => {
    //     return Promise.resolve(res);
    // });
}
export function ImportRenewOrderExcel2Final({userId,importNo}) {
    return request({
        url: `/appi/Operate/ImportRenewOrderExcel2Final?userId=${userId}&importNo=${importNo}`
    })
    // .then(res => {
    //     return Promise.resolve(res);
    // });
}

//获得导入的订单日志列表
export function GetRenewOrderList({userId,ym}) {
    // console.log('bb',userId,sDate,eDate,typeIds,statusId, key)
    return request({
        url: `/appi/Operate/GetRenewOrderList?userId=${encrypt(userId)}&ym=${ym}`
    })
    
}



/**
 * 设置时间
 * @param userId
 * @param productId
 * @returns {AxiosPromise}
 * @constructor
 */
 export function UpdateSheetTime({userId, wsId,createDate,replyDate,finishDate,companyName,contactUser,tel,email,address,account,sheetCode,toUIds,title,content,itemContent}) {
    // return request({url: `/appi/Operate/UpdateSheetTime?userId=${userId}&wsId=${wsId}&createDate=${createDate}&replyDate=${replyDate}&finishDate=${finishDate}`})
    return request({
        url: `/appi/Operate/UpdateSheetTime`,
        data:{
            userId,//encrypt(userId),
            wsId,
            createDate,
            replyDate,
            finishDate,
            companyName,
            contactUser,
            tel,
            email,
            address,
            account,
            sheetCode,
            toUIds,
            title,
            content,
            itemContent,
        }
    });
}


export function AnalisysSurvey({userId,sDate='',eDate='',typeIds=''}) {
    // console.log('bb',userId,sDate,eDate,typeIds,statusId, key)
    return request({
        url: `/appi/Operate/AnalisysSurvey?userId=${userId}&sDate=${sDate}&eDate=${eDate}&typeIds=${typeIds}`
    })
    // return request({url: `/appi/Users/UserList?uId=${userId}&key=${key}`}).then(res=>{
    //     res.data = res.data.map(item=>{
    //         const {typeId, typeName} = item;
    //         return {cateName:typeName, cateId: typeId}
    //     })
    //     return Promise.resolve(res);
    // })
}

/**
 * 导出产品列表
 * @param userId
 * @param key
 * @returns {AxiosPromise}
 */
 export function exportWorkSheetList({userId, sDate,eDate}) {
    return request({
        url: `/appi/Operate/ExportWorkSheetList?userId=${encrypt(userId)}&sDate=${sDate}&eDate=${eDate}`,
        method: 'get',
        responseType: 'blob'
    }).then(res => {
        console.log(res);
        return dealDownloadFileResponse({res});
    })
}


/**
 * 获取工单信息
 * @param userId
 * @param key
 * @returns {AxiosPromise}
 */
 export function GetWorkSheetDetail_Advance({userId,sheetCode}) {    
    return request({url: `/appi/Operate/GetWorkSheetDetail_Advance?userId=${encrypt(userId)}&sheetCode=${sheetCode}`})
}

/**
 * 设置时间
 * @param userId
 * @param productId
 * @returns {AxiosPromise}
 * @constructor
 */
 export function UpdateWorkSheetDealUser({userId, wsId,toUIds}) { 
    // return request({url: `/appi/Operate/UpdateSheetTime?userId=${userId}&wsId=${wsId}&createDate=${createDate}&replyDate=${replyDate}&finishDate=${finishDate}`})
    return request({url: `/appi/Operate/UpdateWorkSheetDealUser?userId=${encrypt(userId)}&wsId=${encrypt(wsId)}&toUIds=${toUIds}`})
   
}



export function SendEmail({userId, wsId}) { 
    return request({
        url: `/appi/Operate/SendEmail?userId=${userId}&wsId=${wsId}`});
}

export function SaveWxFile(data){
    return request({
        url: `/appi/Operate/SaveWxFile`,data
    });
}

export function SaveInfo(data) {
    // console.log('data',data)
    return request({
        url: `/appi/Operate/SaveInfo`,data
        // data:{
        //     id: data.p.id,//encrypt(userId),
        //     sessionCode:data.p.sessionCode,
        //     sheetCode:data.p.sheetCode,
        //     sheetTypeIds:data.p.sheetTypeIds,
        //     title:data.p.title,
        //     content: data.p.content,
        //     alertLevel:data.p.alertLevel,
        //     sample:data.p.sample,
        //     companyType:data.p.companyType,
        //     companyName:data.p.companyName,
        //     jxsName:data.p.jxsName,
        //     contactUser:data.p.contactUser,
        //     tel:data.p.tel,
        //     address:data.p.address,
        //     email:data.p.email,
        //     account:data.p.account
        // }
    });
}

export function GetInfoList({userId,sDate='',eDate='',typeIds='', key = ''}) {
    // console.log('bb',userId,sDate,eDate,typeIds,statusId, key)
    return request({
        url: `/appi/Operate/GetInfoList?userId=${encrypt(userId)}&sDate=${sDate}&eDate=${eDate}&typeIds=${typeIds}&key=${key}`
    })
}

export function GetCompanyInfoByName({userId,companyName}) {
    // console.log('bb',userId,sDate,eDate,typeIds,statusId, key)
    return request({
        url: `/appi/Operate/GetCompanyInfoByName?userId=${encrypt(userId)}&companyName=${companyName}`
    })
}

// 续期访客邀请token（管理员操作）
export function ExtendGuestTokenExpire({fullToken, extendDays = 30}) {
    return request({
        url: `/appi/Users/ExtendGuestTokenExpire?fullToken=${encodeURIComponent(fullToken)}&extendDays=${extendDays}`
    })
}
